export const STATUS_TYPES = {
  LOST_REASON: 'lostReason',
  REASON: 'reason',
  SOURCE: 'source',
}

